// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"b67e8df1","1175":"b67e8df1","3478":"b67e8df1","3895":"b67e8df1","7285":"b67e8df1"}[chunkId] + ".chunk.css";
};